// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDiv {
  width: 100%;
  height: 336px;
  flex-shrink: 0;
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
}

.loadingSection {
  top: 50%;
  left: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.innerDiv {
  display: inline-flexbox;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  height: 264px;
  width: 100%;
  margin-top: 36px;
  /* margin-left: 26%; */
  /* border: 2px solid; */
}

.iconStyle {
  width: 100%;
  height: 120px;
  padding: 0px 10px 15px 10px;
}

.textDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.firstTitle.MuiTypography-root {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  /* 140% */
  letter-spacing: -0.24px;
  margin-left: 4px;
}

.secondTitle.MuiTypography-root {
  color: var(--text-high, rgba(1, 1, 2, 0.72));

  /* Body/B2 Regular */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-left: 4px;
}

.button {
  margin-top: 20px;
  display: flex;
  height: 36px;
  min-width: 60px;
  padding: 0px 24px;
  align-items: center;
  gap: 10px;
}

.createButtonStyle.MuiButtonBase-root.MuiButton-root {
  color: white;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-transform: none;
  display: flex;
  height: 45px;
  /* min-width: 60px; */
  padding: 0px 24px;
  align-items: center;
  border-radius: 8px;
  background: #403e9f;
}

.searchFieldStyling {
  color: var(--text-high, rgba(1, 1, 2, 0.72));
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
}

.dropdown-item:active {
  background-color: var(--generic-primary, #24b7aa);
}

.dropdown-item:visited {
  background-color: var(--generic-primary, #24b7aa);
}

@media screen and (min-width: 521px) {
  .paymentLinkTable {
    display: flex;
    margin-top: 32px;
    display: flex;
  }

  .paymentLinkPhonecontainer {
    display: none;
  }

  .footerStyling {
    display: block;
  }

  .paymentMainDivCreate {
    border-radius: 16px;
    width: 100%;
    flex-shrink: 0;
  }

  .inputField {
    width: 70%;
  }

  .normalCreateButton.MuiButtonBase-root.MuiButton-root {
    display: block;
  }

  .createButton {
    margin-top: 32px;
    width: 30%;
    display: flex;
    justify-content: flex-end;
  }
}

@media (min-width: 521px) and (max-width: 558px) {
  .createButton {
    width: 40%;
  }

  .inputField {
    width: 65%;
  }
}

@media screen and (min-width: 1100px) {
  .createButton {
    margin-left: 170px;
  }
}

@media (min-width: 200px) and (max-width: 520px) {
  .paymentLinkTable {
    display: none;
  }

  .paymentLinkPhonecontainer {
    display: block;
  }

  .footerStyling {
    display: none;
  }

  .accordionDiv {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paymentLinkAccordion.MuiPaper-root.MuiAccordion-root {
    border-radius: 8px !important;
    margin-top: 24px !important;
    box-shadow: none !important;
    width: 100%;
    border: 1px solid var(--text-disabled, rgba(1, 1, 2, 0.12));
  }

  .paymentLinkAccordion.MuiPaper-root.MuiAccordion-root:before {
    background-color: transparent !important;
  }

  .MuiAccordionDetails-root {
    padding: 0px !important;
  }

  .paymentDivMobilePadding {
    margin-left: 20px;
    margin-right: 20px;
  }

  .paymentMainDivCreate {
    width: 100%;
  }

  .firstTitle.MuiTypography-root {
    color: var(--text-high, rgba(1, 1, 2, 0.72));
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    margin-left: 10px;
  }

  .secondTitle.MuiTypography-root {
    margin-left: 10px;
  }

  .titleDiv {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
  }

  .statusDiv {
    padding: 5px 16px;
    border-radius: 2px;
  }

  .detailsContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 0px 16px;
  }

  .paymentUrl {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .inputField {
    width: 100%;
  }

  .MuiButtonBase-root.MuiFab-root {
    border-radius: 8px !important;
    background: #403e9f;
    color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    text-transform: none;
    box-shadow: none;
    display: flex;
    align-items: center;
  }

  .normalCreateButton.MuiButtonBase-root.MuiButton-root {
    display: none;
  }

  .createButton {
    display: none;
  }

  .expandIcon .MuiButtonBase-root.MuiAccordionSummary-root {
    display: flex !important;
    flex-direction: column !important;
  }

  .expandIconContainerTop {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: -20px;
  }

  .expandIconContainerBottom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 6px;
  }

  .summaryContent .MuiAccordionSummary-content {
    margin: 12px 0px 6px 0px !important;
    width: 100%;
  }

  .MuiPaper-root.MuiAccordion-root.Mui-expanded {
    margin: 22px 0px 0px 0px !important;
  }
}

.transaction-detail-page-container {
  border-radius: 1rem;
  padding: 1.5rem 1rem;
  border: 1px solid #ddd;
}

.transaction-detail-page-header {
  display: grid;
  grid-template-columns: 55% 45%;
  /* align-items: center;
  justify-content: space-between; */
  /* padding: 1rem 0; */
}

.transaction-detail-button-div {
  display: flex;
  align-items: center;
}

.description-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3rem;
}

.description-box>* {
  flex: 1 1 100%;
}

.description-unit:not(:first-child) {
  padding-left: 1.5rem;
  border-left: 3px solid #ddd;
}

.payment-link-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 1rem !important;
  font-size: 1.4rem !important;
  font-weight: 500 !important;
}

.description-unit-header {
  font-size: 1.2rem !important;
  font-weight: 600 !important;
  margin-bottom: 0.8rem !important;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/paymentLink/paymentLinks.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;;EAE5C,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;IAC3B,WAAW;IACX,2DAA2D;EAC7D;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4CAA4C;IAC5C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,6DAA6D;IAC7D,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B;mCACiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gCAAgC;AAClC","sourcesContent":[".mainDiv {\n  width: 100%;\n  height: 336px;\n  flex-shrink: 0;\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n}\n\n.loadingSection {\n  top: 50%;\n  left: 50%;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.innerDiv {\n  display: inline-flexbox;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  height: 264px;\n  width: 100%;\n  margin-top: 36px;\n  /* margin-left: 26%; */\n  /* border: 2px solid; */\n}\n\n.iconStyle {\n  width: 100%;\n  height: 120px;\n  padding: 0px 10px 15px 10px;\n}\n\n.textDiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.firstTitle.MuiTypography-root {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  font-family: Poppins;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 28px;\n  /* 140% */\n  letter-spacing: -0.24px;\n  margin-left: 4px;\n}\n\n.secondTitle.MuiTypography-root {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n\n  /* Body/B2 Regular */\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  margin-left: 4px;\n}\n\n.button {\n  margin-top: 20px;\n  display: flex;\n  height: 36px;\n  min-width: 60px;\n  padding: 0px 24px;\n  align-items: center;\n  gap: 10px;\n}\n\n.createButtonStyle.MuiButtonBase-root.MuiButton-root {\n  color: white;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  text-transform: none;\n  display: flex;\n  height: 45px;\n  /* min-width: 60px; */\n  padding: 0px 24px;\n  align-items: center;\n  border-radius: 8px;\n  background: #403e9f;\n}\n\n.searchFieldStyling {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.dropdown-item:active {\n  background-color: var(--generic-primary, #24b7aa);\n}\n\n.dropdown-item:visited {\n  background-color: var(--generic-primary, #24b7aa);\n}\n\n@media screen and (min-width: 521px) {\n  .paymentLinkTable {\n    display: flex;\n    margin-top: 32px;\n    display: flex;\n  }\n\n  .paymentLinkPhonecontainer {\n    display: none;\n  }\n\n  .footerStyling {\n    display: block;\n  }\n\n  .paymentMainDivCreate {\n    border-radius: 16px;\n    width: 100%;\n    flex-shrink: 0;\n  }\n\n  .inputField {\n    width: 70%;\n  }\n\n  .normalCreateButton.MuiButtonBase-root.MuiButton-root {\n    display: block;\n  }\n\n  .createButton {\n    margin-top: 32px;\n    width: 30%;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n@media (min-width: 521px) and (max-width: 558px) {\n  .createButton {\n    width: 40%;\n  }\n\n  .inputField {\n    width: 65%;\n  }\n}\n\n@media screen and (min-width: 1100px) {\n  .createButton {\n    margin-left: 170px;\n  }\n}\n\n@media (min-width: 200px) and (max-width: 520px) {\n  .paymentLinkTable {\n    display: none;\n  }\n\n  .paymentLinkPhonecontainer {\n    display: block;\n  }\n\n  .footerStyling {\n    display: none;\n  }\n\n  .accordionDiv {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .paymentLinkAccordion.MuiPaper-root.MuiAccordion-root {\n    border-radius: 8px !important;\n    margin-top: 24px !important;\n    box-shadow: none !important;\n    width: 100%;\n    border: 1px solid var(--text-disabled, rgba(1, 1, 2, 0.12));\n  }\n\n  .paymentLinkAccordion.MuiPaper-root.MuiAccordion-root:before {\n    background-color: transparent !important;\n  }\n\n  .MuiAccordionDetails-root {\n    padding: 0px !important;\n  }\n\n  .paymentDivMobilePadding {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .paymentMainDivCreate {\n    width: 100%;\n  }\n\n  .firstTitle.MuiTypography-root {\n    color: var(--text-high, rgba(1, 1, 2, 0.72));\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    margin-left: 10px;\n  }\n\n  .secondTitle.MuiTypography-root {\n    margin-left: 10px;\n  }\n\n  .titleDiv {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .statusDiv {\n    padding: 5px 16px;\n    border-radius: 2px;\n  }\n\n  .detailsContent {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 0px 16px;\n  }\n\n  .paymentUrl {\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .inputField {\n    width: 100%;\n  }\n\n  .MuiButtonBase-root.MuiFab-root {\n    border-radius: 8px !important;\n    background: #403e9f;\n    color: var(--text-inverse-highest, rgba(254, 254, 254, 0.92));\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    text-transform: none;\n    box-shadow: none;\n    display: flex;\n    align-items: center;\n  }\n\n  .normalCreateButton.MuiButtonBase-root.MuiButton-root {\n    display: none;\n  }\n\n  .createButton {\n    display: none;\n  }\n\n  .expandIcon .MuiButtonBase-root.MuiAccordionSummary-root {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  .expandIconContainerTop {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin-top: -20px;\n  }\n\n  .expandIconContainerBottom {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin-bottom: 6px;\n  }\n\n  .summaryContent .MuiAccordionSummary-content {\n    margin: 12px 0px 6px 0px !important;\n    width: 100%;\n  }\n\n  .MuiPaper-root.MuiAccordion-root.Mui-expanded {\n    margin: 22px 0px 0px 0px !important;\n  }\n}\n\n.transaction-detail-page-container {\n  border-radius: 1rem;\n  padding: 1.5rem 1rem;\n  border: 1px solid #ddd;\n}\n\n.transaction-detail-page-header {\n  display: grid;\n  grid-template-columns: 55% 45%;\n  /* align-items: center;\n  justify-content: space-between; */\n  /* padding: 1rem 0; */\n}\n\n.transaction-detail-button-div {\n  display: flex;\n  align-items: center;\n}\n\n.description-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 3rem;\n}\n\n.description-box>* {\n  flex: 1 1 100%;\n}\n\n.description-unit:not(:first-child) {\n  padding-left: 1.5rem;\n  border-left: 3px solid #ddd;\n}\n\n.payment-link-name {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 1rem !important;\n  font-size: 1.4rem !important;\n  font-weight: 500 !important;\n}\n\n.description-unit-header {\n  font-size: 1.2rem !important;\n  font-weight: 600 !important;\n  margin-bottom: 0.8rem !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
